import MmenuLight from 'mmenu-light';

document.addEventListener('DOMContentLoaded', () => {
	const menu = new MmenuLight(document.querySelector('#mobile-menu'), '(max-width: 960px)');

	const navigator = menu.navigation({
		// options
		slidingSubmenus: true,
		theme: 'light',
	});

	const drawer = menu.offcanvas({
		// options
		position: 'right',
	});

	navigator.openPanel(document.querySelector('#mobile-menu'));

	document.querySelector('a[href="#open-menu"]').addEventListener('click', (evnt) => {
		evnt.preventDefault();
		drawer.open();
	});
});
